/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../client/js/lib/rest'
import { getHalEmbedded, HalDocument } from '@jalik/hal'

export function deleteRole (id: number) {
  return rest.delete(`/api/roles/${id}`)
}

export function fetchRole (id: number): Promise<Role> {
  return rest.get(`/api/roles/${id}`)
    .then((resp) => resp.json())
}

export function fetchRoleWithPermissions (id: number): Promise<Role> {
  return fetchRole(id)
    .then((role) => rest.get(`/api/roles/${id}/permissions`)
      .then((resp) => resp.json())
      .then((resource: HalDocument<{ permissions: Permission[] }>) => ({
        ...role,
        permissions: (getHalEmbedded(resource)?.permissions || [])
          .map((p) => p.id)
      })))
}

export function fetchRoles (params?: Record<string, any>): Promise<HalDocument<{ roles: Role[] }>> {
  return rest.get(`/api/roles?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchRole (id: number, data: Partial<Role>) {
  return rest.patch(`/api/roles/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postRole (data: Partial<Role>) {
  return rest.post('/api/roles', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
